import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { AlertService } from 'src/app/services/alert.service';
import { kcbtApiService } from 'src/app/services/kcbtApi';
import { ExcelService } from 'src/app/services/excel.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})

export class ReportsComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  grievanceReportData = [];
  dataSource = new MatTableDataSource(this.grievanceReportData)
  form: UntypedFormGroup;
  grievanceTypeDrop: any[] = [];
  grievanceStatusDrop: any[] = [];
  excelColumn = [];
  loading: boolean;
  excelColumns: string[];
  fourtyDays: string;
  yesterday: any;
  minDate: any;
  grievanceTypeDropFilter: any[];
  grievanceStatusDropFilter: any[];
  private grivenceReportData: Subscription
  startDate: Date;
  currentDate: Date;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private apiService: kcbtApiService,
    private excelService: ExcelService,
  ) {
    this.startDate = new Date('01-01-2024');
    this.currentDate = new Date()
  }

  ngOnInit(): void {
    this.initialValidators();
    this.getGrievanceTypeDrop();
    this.getGrievanceStatusDrop();
    this.onFilterGrievance();
    this.dataSource = new MatTableDataSource(this.grievanceReportData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  displayedColumns: any[] = [
    "date",
    "time",
    "referenceNo",
    "grievanceDesc",
    "currentStatusTypeDesc",
  ];

  initialValidators() {
    const currentDate = new Date().toISOString().split('T')[0];
    // const currentDate = moment(this.tomorrow).format('DD-MM-YYYY');

    this.form = this.formBuilder.group({
      fromDate: [this.startDate],
      toDate: [this.currentDate],
      Status: [0],
      GrievanceType: [0]
    })
  }

  clearData() {
    this.dataSource = null;
  }
  onFilterGrievance() {
    if (this.form.valid) {
      const data =
      {
        fromDate: this.form.value.fromDate == 0 ? 0 : moment(this.form.value.fromDate).format('YYYY-MM-DD'),
        toDate: this.form.value.toDate == 0 ? 0 : moment(this.form.value.toDate).format('YYYY-MM-DD'),
        status: this.form.value.Status,
        grievanceType: this.form.value.GrievanceType,
      }

      this.grivenceReportData = this.apiService.getGrievanceReportAll(data).subscribe((res) => {
        this.grievanceReportData = res.map((arr) => {
          arr.dateComponents = arr.date.split("T")[0];
          arr.dateObject = new Date(arr.date);
          return arr;
        }).sort((a, b) => b.dateObject - a.dateObject);;
        this.dataSource = new MatTableDataSource(this.grievanceReportData);
        this.sort.direction = 'asc';
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      })

    } else {
      this.alertService.info("No Data Found")
    }
  }

  refresh() {
    // this.initialValidators();
    // this.onFilterGrievance();
    location.reload();
  }

  applyFilter($event: Event) {
    const filterData = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterData.trim().toLocaleLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getGrievanceTypeDrop() {
    this.apiService.getGrievanceTypeDrop().subscribe((res) => {
      this.grievanceTypeDrop = res.sort((a, b) => a.value.localeCompare(b.value));
      this.grievanceTypeDropFilter = this.grievanceTypeDrop.slice()
    })
  }

  getGrievanceStatusDrop() {
    this.apiService.getGrievanceStatusDrop().subscribe((res) => {
      this.grievanceStatusDrop = res.sort((a, b) => a.value.localeCompare(b.value));
      this.grievanceStatusDropFilter = this.grievanceStatusDrop.slice();
    })
  }
  onExportExcel() {
    this.loading = true;
    setTimeout(() => {
      var exportData = this.grievanceReportData;
      if (!exportData || exportData.length === 0) {
        this.alertService.info("No data available to export");
        return;
      }
      let name: string;
      name = "Grievance Report";
      this.excelColumns = [
        "Date",
        "Time",
        "Reference No",
        "Grievance Type",
        "Current Status",
      ];
      const excelList = [];
      // excelList.push({});
      exportData.forEach((a) => {
        excelList.push({
          date: moment(a.date).format("DD-MM-YYYY"),
          time: moment(a.date).format("HH:MM:SS"),
          ReferenceNo: a.referenceNo,
          grievanceDesc: a.grievanceDesc,
          currentStatusTypeDesc: a.currentStatusTypeDesc,
        });
      });
      this.excelService.exportAsExcelFile(excelList, name, this.excelColumns);
      this.loading = false;
    }, 500);
  }
  
  ngOnDestroy(): void {
    this.grivenceReportData.unsubscribe()
  }
}
